import Vue from 'vue'
import App from './App'
import './registerServiceWorker'
import routerFactory from './router'
import storeFactory from './store'
import i18n from './i18n'
import Vuelidate from 'vuelidate'
import SlideUpDown from 'vue-slide-up-down'
import Vue2TouchEvents from 'vue2-touch-events'
import AOS from 'aos'
import 'aos/dist/aos.css'
import 'animate.css'
import vWow from 'v-wow'
import API from './api'
import helpers from './helpers'
import jQuery from 'jquery'
import VueMeta from 'vue-meta'
import MQ from 'vue-match-media/src'
import VueGtag from 'vue-gtag'
import VueJsonLD from 'vue-jsonld'
// global.$ = global.jQuery = jQuery
window.$ = window.jQuery = jQuery
/* eslint-disable no-unused-vars */
const jqueryWaypoints = require('./legacy/jquery.waypoints.min.js')
const legacyPlugins = require('./legacy/menus')
const legacyTabs = require('./legacy/tabs')
/* eslint-enable no-unused-vars */
import mainMenu from './assets/res/mainMenu.json'
// import MagicScroll from '/public/js/magicscroll.js'

// console.log('*[process.env]', helpers.dumpObj(process.env))

if (!Array.isArray) {
  Array.isArray = function(arg) {
    return Object.prototype.toString.call(arg) === '[object Array]'
  }
}

//import { Trans } from './plugins/Translation'
//Vue.prototype.$i18nRoute = Trans.i18nRoute.bind(Trans)

Vue.use(VueGtag, {
  config: {
    id: 'UA-137922927-1',
    params: {
      send_page_view: true,
    },
  },
})

Vue.config.productionTip = false
Vue.use(Vuelidate)
Vue.use(Vue2TouchEvents)
Vue.use(VueMeta)
Vue.component('slide-up-down', SlideUpDown)
Vue.use(MQ)
Vue.use({
  install() {
    Vue.h = Vue.prototype.$h = helpers
    Vue.API = Vue.prototype.$API = API(Vue)
    Vue.mainMenu = Vue.prototype.$mainMenu = mainMenu
  },
})
Vue.use(VueJsonLD)
// for resolve paths for products categories
// '/700/800/801': '/parentCategory/childCategory1/childCategory2'
Vue.prototype.$cachedCategoryPaths = {}

Vue.filter('stripHTML', function(value) {
  const div = document.createElement('div')
  div.innerHTML = value
  const text = div.textContent || div.innerText || ''
  return text
})

Object.defineProperty(Vue.prototype, '$locale', {
  get: function() {
    return i18n.locale
  },
  set: function(locale) {
    i18n.locale = locale
  },
})

Vue.directive('click-outside', {
  bind(el, binding, vNode) {
    if (typeof binding.value !== 'function') {
      const compName = vNode.context.name
      let warn = `[Vue-click-outside:] provided expression '${binding.expression}' is not a function, but has to be`

      if (compName) {
        warn += `Found in component '${compName}'`
      }

      console.warn(warn)
    }
    const bubble = binding.modifiers.bubble
    const handler = function handler(e) {
      if (bubble || (!el.contains(e.target) && el !== e.target)) {
        binding.value(e)
      }
    }
    el.__vueClickOutside__ = handler

    document.addEventListener('click', handler)
  },
  unbind: function(el) {
    document.removeEventListener('click', el.__vueClickOutside__)
    el.__vueClickOutside__ = null
  },
})

Vue.use(vWow)
// const vm = new Vue({
//   // el: '#app',
//   // render: (h) => h(App),
//   mq: {
//     phone: '(max-width: 768px)',
//     tablet: '(max-width: 1024px)',
//     desktop: '(min-width: 1024px)'
//   }
// })
const store = new storeFactory(Vue)
const router = routerFactory(store, Vue)

const app = new Vue({
  router,
  store,
  i18n,
  mq: {
    xphone: '(max-width: 450px)',
    phone: '(max-width: 768px)',
    stablet: '(max-width: 992px)',
    tablet: '(max-width: 1024px)',
    desktop: '(min-width: 1024px)',
    xtablet: '(min-width: 768px)',
  },
  created() {
    AOS.init()
  },
  render: h => h(App),
}).$mount('#app')

store.$app = app
Vue.APP = Vue.prototype.$APP = app
